/* ========================================
   Artist Profile — Klydo Detail Modal
   Clock face with hands, dials, pendulum
   ======================================== */

let currentArtist = null;
let clockInterval = null;

function updateClockHands() {
  const now = new Date();
  const hours = now.getHours() % 12;
  const minutes = now.getMinutes();
  const seconds = now.getSeconds();

  const hourAngle = (hours + minutes / 60) * 30;
  const minuteAngle = (minutes + seconds / 60) * 6;

  const hourHand = document.getElementById('klydo-modal-hour');
  const minuteHand = document.getElementById('klydo-modal-minute');
  if (hourHand) hourHand.setAttribute('transform', 'rotate(' + hourAngle + ' 100 100)');
  if (minuteHand) minuteHand.setAttribute('transform', 'rotate(' + minuteAngle + ' 100 100)');
}

function renderDials(dialsColor) {
  const dialsGroup = document.getElementById('klydo-modal-dials');
  dialsGroup.innerHTML = '';
  for (let marker = 0; marker < 12; marker++) {
    const angle = marker * 30;
    const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    line.setAttribute('x1', '100');
    line.setAttribute('y1', '12');
    line.setAttribute('x2', '100');
    line.setAttribute('y2', marker % 3 === 0 ? '26' : '22');
    line.setAttribute('stroke', dialsColor || '#fff');
    line.setAttribute('stroke-width', marker % 3 === 0 ? '4' : '3');
    line.setAttribute('stroke-linecap', 'round');
    line.setAttribute('transform', 'rotate(' + angle + ' 100 100)');
    dialsGroup.appendChild(line);
  }
}

function openKlydoModal(klydo) {
  const modal = document.getElementById('klydo-modal');
  const nameEl = document.getElementById('klydo-modal-name');
  const clockEl = document.getElementById('klydo-modal-clock');
  const handsSvg = document.getElementById('klydo-modal-hands');
  const pendulumBob = document.getElementById('klydo-modal-pendulum-bob');
  const pendulumLogo = document.getElementById('klydo-modal-pendulum-logo');
  nameEl.textContent = klydo.name || '';
  clockEl.innerHTML = '';

  const mediaUrl = klydo.loopUrl || klydo.photoUrl || '';
  if (isVideo(mediaUrl)) {
    const video = document.createElement('video');
    video.src = mediaUrl;
    video.autoplay = true;
    video.loop = true;
    video.muted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    clockEl.appendChild(video);
  } else if (mediaUrl) {
    const img = document.createElement('img');
    img.src = mediaUrl;
    img.alt = klydo.name || '';
    clockEl.appendChild(img);
  }

  /* Clock hands and dials */
  const theme = klydo.theme || {};
  const handsColor = theme.handsColor || '#ffffff';

  handsSvg.style.display = '';
  document.getElementById('klydo-modal-dials').innerHTML = '';
  document.getElementById('klydo-modal-hour').setAttribute('stroke', handsColor);
  document.getElementById('klydo-modal-minute').setAttribute('stroke', handsColor);
  document.querySelector('.klydo-modal__hands circle').setAttribute('fill', handsColor);
  updateClockHands();
  if (clockInterval) clearInterval(clockInterval);
  clockInterval = setInterval(updateClockHands, 1000);

  /* Pendulum */
  const backgroundColor = theme.backgroundColor || '#333';
  const pendulumColor = theme.pendulumColor || '#666';
  const rodColor = theme.pendulumRodColor || pendulumColor;
  const pendulumBg = document.getElementById('klydo-modal-pendulum-bg');
  const pendulumRod = document.getElementById('klydo-modal-pendulum-rod');
  pendulumBg.style.background = backgroundColor;
  pendulumRod.style.background = rodColor;
  pendulumBob.style.background = pendulumColor;

  if (klydo.pendulumLogo) {
    pendulumLogo.src = klydo.pendulumLogo;
    pendulumLogo.style.display = '';
  } else {
    pendulumLogo.style.display = 'none';
  }

  modal.classList.add('klydo-modal--open');
  document.body.style.overflow = 'hidden';
}

function closeKlydoModal() {
  const modal = document.getElementById('klydo-modal');
  const clockEl = document.getElementById('klydo-modal-clock');
  modal.classList.remove('klydo-modal--open');
  document.body.style.overflow = '';
  const video = clockEl.querySelector('video');
  if (video) video.pause();
  if (clockInterval) { clearInterval(clockInterval); clockInterval = null; }
}

function initKlydoModalListeners() {
  document.getElementById('klydo-modal-close').addEventListener('click', closeKlydoModal);
  document.getElementById('klydo-modal-backdrop').addEventListener('click', closeKlydoModal);
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') closeKlydoModal();
  });

  const modalShareBtn = document.getElementById('klydo-modal-share');
  modalShareBtn.addEventListener('click', function() {
    const shareUrl = window.location.href;
    if (navigator.share) {
      navigator.share({ title: document.title, url: shareUrl }).catch(function() {});
    } else {
      navigator.clipboard.writeText(shareUrl).then(function() {
        modalShareBtn.classList.add('klydo-modal__action-btn--copied');
        modalShareBtn.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>';
        setTimeout(function() {
          modalShareBtn.classList.remove('klydo-modal__action-btn--copied');
          modalShareBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>';
        }, 2000);
      });
    }
  });
}
